import React, {useState, useEffect, useRef} from "react";
import { ReactSVG } from 'react-svg';
import {Link} from "react-router-dom";
import logo from './images/PMG_logo_icon.svg';
import {ReactComponent as Hamburger} from './images/hamburger_menu_icon.svg';
import {ReactComponent as Close} from './images/close_icon.svg';
import {ReactComponent as Arrow} from './images/arrow_down_icon.svg';
import projectManagementImg from './images/project_management_nav_img.png';
import pmoServicesImg from './images/pmo_services_nav_img.jpg';
import creativeServicesImg from './images/creative_services_nav_img.png';
import rrcLogo from './images/rrc_Logo_icon.svg';
import pmoIcon from './images/pmo-icon.svg';
import Button from "../includes/button";

const servicesLinks = [
    {
        to: "/services",
        target: "_top",
        imgSrc: projectManagementImg,
        alt: "Erica Lester, Director of Strategy & Growth, smiling",
        label: "Fractional Services",
        text: "Senior fractional partners across project management, operations, and design & dev.",
        logoIcon: logo,
        logoAlt: "PMG Logo",
        tag: null
    },
    {
        to: "/pmo-services",
        target: "_top",
        imgSrc: pmoServicesImg,
        alt: "PMG Team",
        label: "ReadyPMO",
        text: "Get access to vetted project managers - without the hassle.",
        logoIcon: pmoIcon,
        logoAlt: "icon of 2 people",
        tag: null
    },
    {
        to: "https://rainroomcreative.com/",
        target: "_blank",
        imgSrc: creativeServicesImg,
        alt: "Rain Room Creative Team",
        label: "Creative Services",
        text: "Web design, content creation, you name it - our team has you covered.",
        logoIcon: rrcLogo,
        logoAlt: "RRC Logo",
        tag: null
    }
];

const Header = () => {
    const [mobileNav, setMobileNav] = useState(false);
    const [servicesDropdown, setServicesDropdown] = useState(false);
    const [activeServiceImage, setActiveServiceImage] = useState(0);
    const [isHoveringProjectManagement, setIsHoveringProjectManagement] = useState(false);
    const servicesDropdownRef = useRef(null);

    const formLink = 'https://tally.so/r/J9BvdK';

    const MobileNav = (action) => {
        if (action === 'close') {
            setMobileNav(false);
        } else if (action === 'open') {
            setMobileNav(!mobileNav);
        }
    }

    const toggleServicesDropdown = (action) => {
        if (action === 'open') {
            setServicesDropdown(true);
        } else if (action === 'close') {
            setServicesDropdown(false);
        }
    }

    useEffect(() => {
        if (mobileNav) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        return () => {
            document.body.style.overflow = '';
        };
    }, [mobileNav]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            // Only handle click outside on mobile/tablet (desktop uses hover)
            if (window.innerWidth < 1024 && servicesDropdownRef.current && !servicesDropdownRef.current.contains(event.target)) {
                setServicesDropdown(false);
            }
        };

        if (servicesDropdown && window.innerWidth < 1024) {
            // Use click instead of mousedown to avoid timing issues
            // Add a small delay to ensure the toggle click has completed
            const timeoutId = setTimeout(() => {
                document.addEventListener('click', handleClickOutside);
            }, 0);

            return () => {
                clearTimeout(timeoutId);
                document.removeEventListener('click', handleClickOutside);
            };
        }

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [servicesDropdown]);

    const navLinkLiClasses = "text-blue70 hover:text-blue transition-all duration-300 ease-in-out font-normal text-sm flex-col justify-start w-full lg:w-max flex items-start justify-start lg:items-start lg:justify-center";
    const navLinkClasses =  "py-6 px-3 justify-start w-full flex items-center w-full h-full lg:justify-center";

    return (
        <div className={"lg:bg-transparent lg:p-9 z-50 flex fixed top-0 w-screen" + (mobileNav ? " h-screen items-start lg:items-center lg:h-fit" : " items-center")}>
            <header className="bg-white lg:backdrop-blur-sm lg:bg-whiteBg flex shrink-0 gap-8 flex-row justify-between items-center w-full relative lg:rounded-2xl">
                <Link to="/" onClick={() => {MobileNav('close'); setServicesDropdown(false);}} className="pl-4 pr-3 py-3">
                    <ReactSVG width="94" src={logo} alt="Partnered Management Group" className="w-[47px] md:block"/>
                </Link>
                <div className="w-auto flex-auto flex flex-col shrink-0 justify-center items-end lg:justify-between lg:items-center lg:flex-row">
                    <div className="block lg:hidden cursor-pointer p-3 mr-4 md:mr-6" onClick={() => MobileNav('open')}>
                        <Hamburger className={mobileNav ? "hidden" : "block"}/>
                        <Close className={mobileNav ? "block" : "hidden"} />
                    </div>
                    <div className={`flex-col absolute top-16 left-0 right-0 lg:top-32 gap-7 lg:flex-row lg:justify-start lg:items-center lg:static lg:w-full lg:justify-between transition-all duration-300 ease-in-out ${mobileNav ? "flex bg-backgroundWhite w-screen h-[90vh] justify-between opacity-100 translate-y-0 visible" : "opacity-0 -translate-y-4 pointer-events-none invisible lg:opacity-100 lg:translate-y-0 lg:visible lg:pointer-events-auto lg:flex"}`}>
                        <ul className="flex text-blue70 font-normal text-sm flex-col gap-7 justify-start lg:flex-row lg:justify-start lg:items-center p-6 lg:p-0 max-h-[80vh] overflow-y-scroll lg:overflow-y-visible">
                            <li className={navLinkLiClasses}>
                                <Link to="/about" onClick={() => {setServicesDropdown(false); MobileNav('close');}} className={navLinkClasses}>
                                    Why PMG?
                                </Link>
                            </li>
                            <li className={navLinkLiClasses + " lg:block cursor-pointer"} ref={servicesDropdownRef} onMouseEnter={() => {
                                // Only use hover on desktop
                                if (window.innerWidth >= 1024) {
                                    toggleServicesDropdown('open');
                                }
                            }} onMouseLeave={() => {
                                // Only use hover on desktop
                                if (window.innerWidth >= 1024) {
                                    toggleServicesDropdown('close');
                                }
                            }}>
                                <span onClick={(e) => {
                                    e.stopPropagation();
                                    // Toggle on mobile/tablet, open only on desktop (hover handles closing)
                                    if (window.innerWidth < 1024) {
                                        toggleServicesDropdown(servicesDropdown ? 'close' : 'open');
                                    } else {
                                        toggleServicesDropdown('open');
                                    }
                                }} className={navLinkClasses + " relative"}>
                                    Services
                                    <Arrow className={`inline-block ml-1 transition-transform duration-300 lg:rotate-0 ${servicesDropdown ? 'rotate-0' : 'rotate-[-90deg]'}`} />
                                </span>
                             <div
  className={`
    ${servicesDropdown ? "opacity-100 translate-y-0 max-h-[1000px] visible" : "opacity-0 -translate-y-2 pointer-events-none max-h-0 overflow-hidden invisible lg:visible lg:max-h-none lg:opacity-0"}
    transition-all duration-300 ease-out
    bg-transparent lg:pt-2 lg:absolute z-10 w-content
  `}
>
  <div className="flex bg-backgroundWhite flex-row items-stretch rounded-lg py-2 md:p-2 border border-solid border-borderPrimary gap-4 lg:max-w-[640px] w-full">
    <ul className="flex-col gap-0.5 h-full flex-1.5 w-full lg:w-auto">
      {servicesLinks.map((link, index) => (
        <li
          key={index}
          onMouseEnter={() => {
            setActiveServiceImage(index);
            setIsHoveringProjectManagement(index === 0);
          }}
          onMouseLeave={() => {
            setIsHoveringProjectManagement(false);
          }}
          onClick={() => {
            setServicesDropdown(false);
            MobileNav("close");
          }}
        >
          <Link
            to={link.to}
            target={link.target}
            className="flex flex-row items-start gap-4 py-3 px-4 bg-white hover:bg-grey90/10 transition-all duration-300 ease-in-out rounded-lg"
          >
            <div className="flex items-center justify-center">
              <img
                src={index === 0 && isHoveringProjectManagement ? projectManagementImg : link.imgSrc}
                alt={index === 0 && isHoveringProjectManagement ? "Erica Lester, Director of Strategy & Growth, smiling" : link.alt}
                className="flex object-cover object-center w-32 h-20 md:w-24 md:h-24 md:aspect-square rounded-md lg:hidden"
              />
              <ReactSVG
                width="24"
                height="24"
                src={link.logoIcon}
                alt={link.logoAlt}
                className="dropdown-icon w-[24px] h-[24px] hidden lg:flex object-contain aspect-square"
              />
            </div>

            <div className="flex flex-col gap-1 items-start justify-start">
              <span className="text-xs lg:text-base font-bold font-sans text-left flex items-center justify-start w-max">
                {link.label}
                {link.tag && (
                  <span className="ml-2 text-[10px] lg:text-xs font-normal font-body text-secondaryNew bg-backgroundWhite px-2 py-0.5 border border-solid border-borderPrimary rounded-md drop-shadow-sm text-center w-max">
                    {link.tag}
                  </span>
                )}
              </span>
              <p className="text-xs lg:text-sm font-normal font-body text-left">
                {link.text}
              </p>
            </div>
          </Link>
        </li>
      ))}
    </ul>

    <div className="w-72 aspect-square hidden lg:flex items-center justify-center">
      <img
        src={isHoveringProjectManagement ? projectManagementImg : servicesLinks[activeServiceImage].imgSrc}
        alt={isHoveringProjectManagement ? "Erica Lester, Director of Strategy & Growth, smiling" : servicesLinks[activeServiceImage].alt}
        className="flex object-cover w-full h-full object-center rounded-md"
      />
    </div>
  </div>
</div>

                            </li>
                            <li className={navLinkLiClasses}>
                                <Link to="/pricing" onClick={() => {setServicesDropdown(false); MobileNav('close');}} className={navLinkClasses}>
                                    Pricing
                                </Link>
                            </li>
                            <li className={navLinkLiClasses}>
                                <Link to="/portfolio" onClick={() => {setServicesDropdown(false); MobileNav('close');}} className={navLinkClasses}>
                                    Case Studies
                                </Link>
                            </li>
                            <li className={navLinkLiClasses}>
                                <Link to="https://portal.partneredmg.com" onClick={() => {setServicesDropdown(false); MobileNav('close');}} target="_blank" className={navLinkClasses}>
                                    Client Portal
                                </Link>
                            </li>
                        </ul>
                        <div className="w-full p-6 lg:p-3 border-t border-t-solid border-t-FG-Neutral-Accent lg:border-t-0 flex justify-center lg:justify-end lg:min-w-44" onClick={() => MobileNav('close')}>
                            <Button to={formLink} label="Make an Inquiry" variant="light-primary" isHashLink={false} target="_blank"/>
                        </div>
                    </div>
                </div>
            </header>
        </div>
    );
}

export default Header;


